export default {
  title: 'Adicionar parceiro',
  mode: {
    single: 'Parceiro único',
    bulk: 'Em massa (CSV)',
  },
  buttons: {
    send_invite: 'Enviar convite',
  },
  bulk: {
    form: {
      file: {
        label: 'Lista de parceiros (CSV)',
        hint: 'Um parceiro por linha. Colunas obrigatórias: Email, País da empresa e Nome registado da empresa ou Nome da empresa. O nome da marca é opcional e torna-se o nome de apresentação ao consumidor. Cada linha é validada antes de qualquer criação.',
      },
    },
    buttons: {
      select_file: 'Selecionar ficheiro CSV',
      download_template: 'Transferir modelo de importação',
      import: 'Importar parceiros',
    },
    columns: {
      legal_name: 'Nome registado da empresa / Nome da empresa',
      display_name: 'Nome da marca',
      admin_email: 'Email',
      company_country: 'País da empresa',
    },
    errors: {
      title: 'Não foi possível importar o ficheiro.',
      nothing_imported: 'Nenhum parceiro foi criado. Corrija as linhas acima e carregue novamente o ficheiro.',
      columns: {
        row: 'Linha',
        column: 'Coluna',
        error: 'Erro',
      },
    },
    toasts: {
      queued_one:
        '{{count}} parceiro em fila — os convites são enviados à medida que cada um é criado. Receberá um email de resumo quando a importação terminar.',
      queued_other:
        '{{count}} parceiros em fila — os convites são enviados à medida que cada um é criado. Receberá um email de resumo quando a importação terminar.',
    },
    footnote:
      'Os parceiros são criados um a um em segundo plano com a mesma configuração de um parceiro individual: email de convite, subdomínio do painel e domínio de loja predefinido. O país determina a moeda e o fuso horário; o estado pode ser definido mais tarde no perfil do parceiro. O processamento de pagamentos é configurado depois no separador Pagamentos de cada parceiro.',
  },
  form: {
    name: {
      label: 'Nome do parceiro',
    },
    admin_email: {
      label: 'Email do administrador (destinatário do convite)',
      hint: 'Enviaremos um convite por email para configurar a conta.',
    },
    display_name: {
      label: 'Nome de exibição ao consumidor',
      hint: 'O rótulo «Powered by ___» mostrado aos clientes. Por omissão, usa o nome do parceiro se deixado em branco.',
    },
    region: {
      label: 'País',
      placeholder: 'Selecionar um país',
      hint: 'Define a moeda, o fuso horário e o idioma do convite do parceiro.',
      summary: 'Moeda {{currency}} · {{timezone}} · Idioma do convite {{language}}',
      default_root: 'Domínio da loja: novas marcas são servidas em {{host}}',
    },
    sub_region: {
      label: 'Estado/Região',
      placeholder: 'País inteiro',
      hint: 'Opcional — deixe em branco para aplicar a todo o país.',
    },
    language: {
      label: 'Idioma do convite',
      placeholder: '{{language}} (predefinição)',
      hint: 'Opcional — usa por omissão o idioma principal do país.',
    },
  },
  footnote: 'As definições de marca e ganhos podem ser configuradas após o parceiro aceitar o convite.',
  toasts: {
    created: 'Parceiro criado — o email de convite está a caminho.',
  },
};
